// /*global kakao*/
import React, { useEffect } from 'react'

const JungjinMap = () => {

  // useEffect(() => {
  //   var container = document.getElementById('map');
  //   var options = {
  //     center: new window.kakao.maps.LatLng(35.9019704, 128.587826),
  //     level: 1
  //   };

  //   var map = new window.kakao.maps.Map(container, options);
  //   var markerPosition = new window.kakao.maps.LatLng(35.9019704, 128.587826);
  //   var marker = new window.kakao.maps.Marker({
  //     position: markerPosition
  //   });
  //   marker.setMap(map);

  // }, [])

  useEffect(() => {
    if (window.kakao && window.kakao.maps) {

      window.kakao.maps.load(() => {
        const container = document.getElementById('map')
        if (container) {
          const centerPos = new window.kakao.maps.LatLng(35.9019704, 128.587826);
          const options = {
            center: centerPos,
            level: 3
          };
          const map = new window.kakao.maps.Map(container, options);

          const marker = new window.kakao.maps.Marker({
            position: centerPos
          });
          marker.setMap(map);
        }
      });
    }
  }, []);


  return (
    <>
      <div>
        <h3 style={{ textAlign: 'center', color: 'darkBlue', backgroundColor: 'lightgray' }}>1공장:정진피엔지 [아연피막,칼슘피막,착색,에칭]</h3>
        <div>
          <div id="map" style={{ width: "100%", height: "70vh" }}></div>
        </div>
        &nbsp;
        <h5 style={{ textAlign: 'center' }}>주소 : 대구시 북구 침산동 67길7 (침산동)</h5>
      </div>
    </>
  )
}


export default JungjinMap;